// On mount (or when ?import=1 changes), consume the sessionStorage
// AutoImportPayload and surface it as an initial JobFormState plus a
// strip-the-query-string side effect.
import { useEffect, useState } from "react";
import type { JobFormState } from "../modals/JobFormFields";
import {
  autoImportToFormState,
  consumeAutoImport,
} from "../lib/autoImport";

export function useAutoImport(search: URLSearchParams): {
  initial: JobFormState | null;
  clear(): void;
} {
  const [initial, setInitial] = useState<JobFormState | null>(null);

  useEffect(() => {
    if (search.get("import") !== "1") return;
    const payload = consumeAutoImport();
    if (!payload) return;
    setInitial(autoImportToFormState(payload));
    const next = new URLSearchParams(search);
    next.delete("import");
    const qs = next.toString();
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${qs ? `?${qs}` : ""}`,
    );
  }, [search]);

  return { initial, clear: () => setInitial(null) };
}
